import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Box, CircularProgress, Button } from '@mui/material';
import { TreeViewComponent } from '@syncfusion/ej2-react-navigations';
import { useNavigate, useLocation } from 'react-router-dom';

// Memoized to avoid unnecessary re-renders
//const ConnectionTreeView = React.memo(function ConnectionTreeView({ dataSource, onNodeSelected, nodeTemplate, selectedNodes }) {
//    // Only re-create fields if dataSource changes
//    const fields = {
//        dataSource,
//        id: 'id',
//        text: 'name',
//        child: 'children'
//    };
//    console.log('render TreeView');
//    // Use useCallback to avoid function recreation unless handler changes
//    const handleNodeSelected = useCallback(onNodeSelected, [onNodeSelected]);

//    return (
//        <TreeViewComponent
//            fields={fields}
//            nodeTemplate={nodeTemplate}
//            nodeSelected={handleNodeSelected}
//            selectedNodes={selectedNodes }
//        />
//    );
//});
const ConnectionTreeView = ({
    //onNode Selected handler event
    onNodeSelected,
    // node Template to load
    //nodeTemplate,
    refreshTree,
    //Reference to SelectedNode
    selectedNode,
    isDraggable,
    //Reference to TreeViewComponent
    reference
}) => {
    const [connections, setConnections] = useState([]);
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const treeContainerRef = useRef();
    const pageSize = 20;
    const navigate = useNavigate();
    const location = useLocation();

    async function fetchConnections(pageToFetch = 1) {
        setLoading(true);
        try {
            const response = await fetch(`/api/connection?page=${pageToFetch}&pageSize=${pageSize}` + (isDraggable ? '&onlyWithActionsOrEvents=true' : ''), {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                if (pageToFetch === 1) {
                    setConnections(data.connections);
                } else {
                    setConnections(prev => [...prev, ...data.connections]);
                }
                setHasMore(data.connections.length === pageSize);
            }
        } catch (error) {
            console.error('Error fetching connections:', error);
            setConnections([]);
        } finally {
            setLoading(false);
        }
    }

    function proccessDataSource(connections) {
        let dataSour = connections.map((con) => {
            let actions = con.actions.map((act) => ({ ...act, name: act.name.substring(0, 20) + (act.name.length > 20 ? '...' : ''), connectionId: con.id, isAction: true, selected: false }));
            let events = con.events.map((ev) => ({ ...ev, name: ev.name.substring(0, 20) + (ev.name.length > 20 ? '...' : ''), connectionId: con.id, isEvent: true, selected: false }));
            let definers = [
                {
                    id: con.id + '|actions', name: 'actions', expanded: true,
                    treeViewType: 'ActionDefiner', parentId: con.id, children: actions, selected: false
                },
                {
                    id: con.id + '|events', name: 'events', expanded: true,
                    treeViewType: 'EventDefiner', parentId: con.id, children: events, selected: false
                }
            ];
            return {
                ...con, name: con.name.substring(0, 20) + (con.name.length > 20 ? '...' : ''), treeViewType: 'Connection', expanded: false, children: definers, selected: false
            }
        });
        setDataSource(dataSour);
    }

    const handleNavigation = (path) => {
        if (location.pathname !== path) {
            navigate(path); // Navigate only if the path is different
        }
    };

    // TreeView node template
    const nodeTemplate = useCallback((data) => {
        if (isDraggable) {
            const isDraggable = !['ActionDefiner', 'EventDefiner'].includes(data.treeViewType);
            return (
                <div
                    draggable={isDraggable}
                    onDragStart={isDraggable ? (e) => {
                        e.dataTransfer.setData('application/json', JSON.stringify(data));
                    } : undefined}
                    style={{ cursor: isDraggable ? 'grab' : 'default' }}
                >
                    {data.name}
                </div>
            );
        } 
        const isParentOrRoot = data.treeViewType === 'EventDefiner' || data.treeViewType === 'ActionDefiner';
        let styleg = { display: 'flex', alignItems: 'center', gap: 4 };
        let stylespan = {};
        if (data.treeViewType === 'Connection') {
            stylespan = { fontSize: '1.2em' };
        }
        if (isParentOrRoot) {
            stylespan = { fontSize: '1.0em' };
        }
        return (
            <div style={styleg}>
                <span style={stylespan}>{data.name}</span>
                {isParentOrRoot && (
                    <Button
                        size="small"
                        onClick={e => {
                            e.stopPropagation();
                            if (data.treeViewType === 'ActionDefiner') {
                                handleNavigation(`/connections/${data.parentId}/actions/new`);
                            }
                            if (data.treeViewType === 'EventDefiner') {
                                handleNavigation(`/connections/${data.parentId}/events/new`);
                            }
                        }}
                    >+</Button>
                )}
            </div>
        );
    }, []);

    const draggableNodeTemplate = (data) => {
        console.log(data);
        const isDraggable = !['ActionDefiner', 'EventDefiner'].includes(data.treeViewType);
        return (
            <div
                draggable={isDraggable}
                onDragStart={isDraggable ? (e) => {
                    e.dataTransfer.setData('application/json', JSON.stringify(data));
                } : undefined}
                style={{ cursor: isDraggable ? 'grab' : 'default' }}
            >
                {data.name}
            </div>
        );
    };

    // Recursively get complete related Data of node
    function getTreeData(dataSource, nodeId) {
        if (!dataSource) return null;
        for (const node of dataSource) {
            if (node.id === nodeId) return node;
            if (node.children && node.children.length > 0) {
                const found = getTreeData(node.children, nodeId);
                if (found) return found;
            }
        }
        return null;
    }

    const handleScroll = () => {
        const container = treeContainerRef.current;
        if (!container || !hasMore) return;
        if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10) {
            // Near bottom, load more
            fetchConnections(page + 1);
            setPage(prev => prev + 1);
        }
    };

    useEffect(() => {
        console.log(isDraggable);
        fetchConnections(1);
        if (selectedNode) {
            selectedNode.current = {};
        }
    }, []);

    useEffect(() => {
        console.log('refreshing tree');
        console.log(refreshTree);
        if (refreshTree) {
            fetchConnections(1);
            if (selectedNode) {
                selectedNode.current = {};
            }
        }
    }, [refreshTree]);

    useEffect(() => {
        proccessDataSource(connections);
    }, [connections]);

    return (
        <Box
            ref={treeContainerRef}
            sx={{ height: 520, overflowY: 'auto' }}
            onScroll={handleScroll}
        >
            <TreeViewComponent
                fields={{ dataSource, id: 'id', text: 'name', child: 'children' }}
                nodeTemplate={nodeTemplate}
                nodeSelecting={(args) => {
                    // Block any select / unselect attempts
                    if (isDraggable) {
                        args.cancel = true;
                    }
                }}
                nodeSelected={(args) => {
                    if (selectedNode) {
                        selectedNode.current = args.nodeData;
                    }
                    const nodeId = args.nodeData.id;
                    const nodeData = getTreeData(dataSource, nodeId);
                    onNodeSelected(nodeData);
                }}
                //selectedNodes={selectedNodes}
                ref={(tree) => { reference.current = tree; }}
            />
            {loading && (
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    py: 2
                }}>
                    <CircularProgress size={24} />
                </Box>
            )}
        </Box>
        
    );
};

export default ConnectionTreeView;